import { createAction, props } from "@ngrx/store";
import { ProjectDetailsModel } from "../../widgets/staar/models/project-details";

export const setProject = createAction(
  '[Projects] Set Project',
  props<{ project: ProjectDetailsModel }>()
)